import { createActions } from "redux-actions";

/**
 * The constants here need to match the related actions. The actions
 * themselves are CONSTANT_CASED, but the related constants are camelCased
 * based on the _, so CONSTANT_CASED becomes constantCased, and something
 * like SOME_DUMB_THING is someDumbThing. Kinda dumb, but w/e.
 */
export const {
    checkinSetAnswer,
    checkinRemoveAnswer,
    checkinResetAnswers,
    checkinReset,
    checkinSetNudged,
} = createActions(
    "CHECKIN_SET_ANSWER",
    "CHECKIN_REMOVE_ANSWER",
    "CHECKIN_RESET_ANSWERS",
    "CHECKIN_RESET",
    "CHECKIN_SET_NUDGED",
);
